<template>
  <div id="app">
    <navbar v-if="!loading" :session="session"></navbar>
    <router-view v-if="!loading" :session="session" class="view" />
    <div v-else class="loading">
      <h1>{{ loadingMessage }}{{ dots }}</h1>
    </div>
  </div>
</template>

<script>
import Navbar from "./components/Navbar";

import config from "./config";

export default {
  name: "App",
  components: {
    navbar: Navbar
  },
  data() {
    return {
      loading: true,
      loadingMessage: "Loading",
      counter: 0,
      session: {}
    };
  },
  methods: {
    validateToken() {
      this.loading = true;
      this.loadingMessage = "Loading";

      setTimeout(() => {
        this.loadingMessage = "Starting Servers";
      }, 1000);

      const token = localStorage.getItem("token");

      this.axios
        .get(config.api + "/session", {
          headers: {
            authorization: token
          }
        })
        .then(result => {
          this.loading = false;
          this.session = result.data;
        })
        .catch(() => {
          this.loading = false;
          this.$router.push("/unauthenticated");
        });
    }
  },
  watch: {
    $route: function() {
      if (this.$route.name === "Authenticate") return;

      this.validateToken();
    }
  },
  computed: {
    dots: function() {
      const amount = this.counter % 4;

      let dots = "";

      for (let i = 0; i < amount; i++) {
        dots += ".";
      }

      return dots;
    }
  },
  created() {
    this.validateToken();
    this.$router.push('/')

    setInterval(() => {
      this.counter += 1;
    }, 500);
  }
};
</script>

<style>
html,
body,
#app,
.loading {
  margin: 0;
  padding: 0;
  height: 100vh;

  width: 100%;
  background: rgb(13, 26, 28);
  background: linear-gradient(
    146deg,
    rgba(13, 26, 28, 1) 0%,
    rgba(70, 70, 70, 1) 58%,
    rgba(43, 41, 41, 1) 100%
  );
}

* {
  font-family: "Josefin Sans", sans-serif;

  color: white;
}

input,
select,
button {
  border: none;
  border-radius: 5px;
  background-color: rgb(83, 83, 83);
  color: white;

  padding: 5px;
  margin: 2px 0;
  font-size: 15px;
}

input::placeholder,
input:-ms-input-placeholder,
input::-ms-input-placeholder {
  color: rgb(255, 255, 255);
  opacity: 1;
}

button {
  cursor: pointer;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

button.secondary {
  border-radius: 0px;
  background-color: transparent;
  text-decoration: underline;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;

}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr {
  cursor: pointer;
  background-color: none;

  transition: .2s;
}

tr:hover {
  background-color: #dddddd;

  transition: .2s;
}

tr:hover > td {
  color: black;

  transition: .2s;
}

tr:hover > td > span {
  color: black;

  transition: .2s;
}

tr:active {
  background-color: black;
  color: white;
}

tr:active > td {
  color: white;
}

tr:active > td > span {
  color: white;
}

</style>



// WEBPACK FOOTER //
// src/App.vue